// import {store} from 'Store/store.index';
// console.log(store)
// let { userData } = store.userNewStore

export const HELP_CUSTOMER_SERVICE ='help-customer-service';
export const HELP_ABOUT ='help-about';
export const HELP_OPEN_MEMBER ='help-open-member';
export const HELP_EXCHANGE_MEMBER ='help-exchange-member';
export const HELP_MAP = {
    customerService: {
      name: HELP_CUSTOMER_SERVICE,
      title: 'phantom_online:toolbar.fwHelp.customerService',
      icon:'fx-icon-ribbon_help_post_your_idea-32'
    },
    about: {
      name: HELP_ABOUT,
      title: 'phantom_online:toolbar.fwHelp.about',
      icon:'fx-icon-ribbon_help_about_foxit_phantompdf-32'
    },
    openMember: {
      name: HELP_OPEN_MEMBER,
      // title: `${userData && userData.identity !== "vip" ? 'phantom_online:toolbar.fwHelp.openMemberAgain' : 'phantom_online:toolbar.fwHelp.openMember' }`,
      title: 'phantom_online:toolbar.fwHelp.openMember',
      icon:'fw__icon-toolbar-open-member'
    },
    exchangeMember: {
      name: HELP_EXCHANGE_MEMBER,
      title: 'phantom_online:toolbar.fwHelp.exchangeMember',
      icon:'fw__icon-toolbar-exchange-member'
    },
}
